import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpenIcon } from 'lucide-react';
export function TheSystem() {
  const tomos = [{
    num: '1',
    title: 'Fundamentos del Método HYROX',
    desc: 'La base conceptual de todo el sistema. Tu criterio cambia para siempre. Dejás de ver HYROX como "funcional con carrera" y empezás a entender las demandas reales del deporte: resistencia aeróbica, fuerza resistente, tolerancia al lactato, eficiencia técnica y transición.'
  }, {
    num: '2',
    title: 'Programación Inteligente',
    desc: 'Tu año entero tiene lógica, estructura y progresión. El Tomo 2 te da el sistema para planificar bloques, semanas e intensidades con criterio. Nunca más improvisás sesiones ni repetís siempre lo mismo sin dirección.'
  }, {
    num: '3',
    title: 'Anatomía de la Clase HYROX',
    desc: 'Tus clases tienen estructura, ritmo y propósito real. Briefing, calentamiento específico, bloque técnico, conditioning y vuelta a la calma. Cada parte cumple una función. Cada sesión conecta con la siguiente.'
  }, {
    num: '4',
    title: 'Evaluación y Seguimiento',
    desc: 'Tus alumnos ven su progreso en papel. Tests físicos, fichas de calidad de movimiento, seguimiento semanal, re-test comparativo y análisis post-carrera. El sistema que hace visible el trabajo invisible.'
  }, {
    num: '5',
    title: 'Corrección Técnica de las 8 Estaciones',
    desc: 'Nunca más dudás al corregir. Errores más comunes en cada estación, cuándo y cómo intervenir, lenguaje de corrección efectivo y progresiones de aprendizaje motor para SkiErg, Sled, Row, Burpees, Carry, Lunges y Wall Balls.'
  }, {
    num: '6',
    title: 'El Negocio del Coach HYROX',
    desc: 'Tu negocio deja de funcionar de casualidad. Cómo posicionarte como especialista, cómo cobrar lo que valés, cómo comunicar tu propuesta y cómo diferenciarte en un mercado que todavía no entiende la diferencia entre un profe de funcional y un coach HYROX de verdad.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-hyrox-dark" data-id="element-207">
      <div className="max-w-6xl mx-auto" data-id="element-208">
        <FadeIn data-id="element-209">
          <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-210">
            <h2 className="text-4xl sm:text-6xl font-display font-black text-white mb-6 uppercase tracking-tight" data-id="element-211">
              EL <span className="text-hyrox-orange" data-id="element-212">MEGA PACK HYROX</span>
              <br data-id="element-213" />
              ES ESE SISTEMA.
            </h2>
            <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-214">
              No es una colección de PDFs sueltos. No es contenido de YouTube
              organizado en documentos. No es un manual teórico sin aplicación
              práctica.
            </p>
            <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-215">
              Es el sistema completo que transforma la forma en que trabajás
              como coach de HYROX. De la planificación anual hasta la corrección
              técnica en tiempo real. Del seguimiento individual hasta el
              posicionamiento de negocio.
            </p>
            <p className="text-xl sm:text-2xl font-bold text-white" data-id="element-216">
              Todo conectado. Todo con criterio. Todo listo para usar desde hoy.
            </p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-217">
          <h3 className="text-2xl font-display font-bold text-center text-hyrox-orange mb-10" data-id="element-218">
            Los 6 tomos que entran al sistema cuando comprás el pack:
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-219">
          {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-220">
              <div className="bg-hyrox-surface border border-hyrox-muted rounded-2xl p-6 sm:p-8 h-full relative overflow-hidden group hover:border-hyrox-orange/40 transition-all" data-id="element-221">
                <div className="absolute top-0 right-0 text-[120px] font-black text-hyrox-dark leading-none -mt-4 -mr-4 pointer-events-none group-hover:text-hyrox-orange/5 transition-colors" data-id="element-222">
                  {tomo.num}
                </div>
                <div className="relative z-10" data-id="element-223">
                  <div className="flex items-center gap-3 mb-4" data-id="element-224">
                    <div className="bg-hyrox-orange/10 text-hyrox-orange p-2 rounded-lg" data-id="element-225">
                      <BookOpenIcon className="w-6 h-6" data-id="element-226" />
                    </div>
                    <span className="text-hyrox-orange font-bold tracking-wider text-sm uppercase" data-id="element-227">
                      Tomo {tomo.num}
                    </span>
                  </div>
                  <h4 className="text-2xl font-display font-bold text-white mb-4" data-id="element-228">
                    {tomo.title}
                  </h4>
                  <p className="text-gray-400 leading-relaxed" data-id="element-229">{tomo.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}